import React, {useState, useEffect, useRef} from "react";
import {observer, inject} from "mobx-react";
import classnames from "classnames";
import isRetina from "is-retina"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import getBoxPadUrl from "@utils/getBoxPadUrl"
import Modal from "@components/react-responsive-modal/modal";
import {Helmet} from 'react-helmet';
import objectFitImages from 'object-fit-images';
import Accordion from "@components/Accordion/Accordion";
import Footer from "@templates/footer";
import ProductCard from "@components/Products/ProductCard";
import IComImageSlider from "@components/IComImageSlider/IComImageSlider";
//import IComImageMap from "@components/IComImageMap/IComImageMap";
//import ImageSorter from "@utils/ImageSorter";
import StructuredDataProduct from "@components/StructuredData/StructuredDataProduct";
import {QuantityEdit} from "./QuantityEdit";

// Hook
function useOnScreen(ref, rootMargin = '0px') {
    // State and setter for storing whether element is visible
    const [isIntersecting, setIntersecting] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // Update our state when observer callback fires
                setIntersecting(entry.isIntersecting);
            },
            {
                rootMargin: rootMargin,
                threshold: 0.1
            }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }
        return () => {
            if (ref && ref.current)
                observer.unobserve(ref.current);
        };
    }, []); // Empty array ensures that effect is only run on mount and unmount

    return isIntersecting;
}


const HideIfOnScreen = props => {
    const {useRef} = props;

    if (useOnScreen(useRef)) {
        return null;
    }

    return <div>{props.children}</div>;
};

const SizeInformation = props => {
    const {navigation, activeProduct, selectedSizeValue} = props;

    if (!activeProduct.SizeInformationId) {
        return null;
    }

    const productSizeInformation = navigation.getSizeInformation(activeProduct);

    let sizeInformation = null;
    if (productSizeInformation && selectedSizeValue) {
        let productSizeInformationVariant = productSizeInformation.Variants.find(function (item) {
            return item.VariantSku === selectedSizeValue;
        });
        if (productSizeInformationVariant) {
            sizeInformation = productSizeInformationVariant;
        }
    }

    const splitDescriptionString = (value) => {
        let result = [];
        if (value.indexOf('\n') > -1) {
            const lines = value.split('\n');
            for (let i = 0, l = lines.length; i < l; i++) {
                const line = lines[i];

                let key = "";
                let value = line;
                if (line.indexOf(':') > -1) {
                    key = line.split(':')[0];
                    value = line.split(':')[1];
                }
                result.push({'key': key, 'value': value});
            }
        } else {
            result.push({'key': '', 'value': value});
        }
        return result;
    }

    if (productSizeInformation) {
        return <div
            className={"size-information-container " + (!selectedSizeValue ? " size-variant-not-selected" : "")}>
            <div className={"size-product-info"}>
                {productSizeInformation &&
                    productSizeInformation.ShortDescription &&
                    <p>{productSizeInformation.ShortDescription}</p>}
                {productSizeInformation &&
                    productSizeInformation.LongDescription &&
                    <div className={"long-description"}
                         dangerouslySetInnerHTML={{
                             __html:
                             productSizeInformation
                                 .LongDescription
                         }}/>}
            </div>
            {sizeInformation &&
                <div className={"size-variant-info"}>
                    {sizeInformation.DisplayName &&
                        <div className={"size-variant-info-title"}>{sizeInformation.DisplayName}</div>}
                    {sizeInformation.ShortDescription &&
                        <div
                            className={"short-description-rows"}>{splitDescriptionString(sizeInformation.ShortDescription).map(
                            (line, index) => {
                                return (
                                    <div className={"short-description-row"} key={"short-description-row-" + index}>
                                        {line["key"] &&
                                            <div className={"short-description-row-key"}>{line["key"]}</div>}
                                        {line["value"] &&
                                            <div className={"short-description-row-value"}>{line["value"]}</div>}
                                    </div>)
                            })}</div>}
                    {sizeInformation.LongDescription &&
                        <div className={"long-description"}
                             dangerouslySetInnerHTML={{
                                 __html: sizeInformation.LongDescription
                             }}/>}

                </div>}
        </div>;
    } else {
        return null;
    }
}

const MobileFloatingWrapper = props => {
    const {navigation, productNames, activeProduct, hideTitleIfRefOnScreen, selectedSizeValue, wrapperRef} = props;
    //const myRef = useRef();
    const onScreen = useOnScreen(wrapperRef);
    
    //if (floatingContainerCallback) {
    //    if (navigation.viewPortWidth <= 991 && !onScreen) {
    //        floatingContainerCallback({
    //            Action: "add",
    //            Item: { Key: sortOrder, SortOrder: sortOrder, Value: <div>{props.children}</div> }
    //        });
    //    } else {
    //        debugger;
    //        //floatingContainerCallback({ Action:"remove", Item:{Key: sortOrder}});
    //    }
    //}
    
    return <React.Fragment>
        {props.children}
        {navigation.viewPortWidth <= 991 && !onScreen && !navigation.isBot
        ? <div className="mobile-floating-wrapper">
            <HideIfOnScreen useRef={hideTitleIfRefOnScreen}>

                <h1 className="product-name">{productNames[0].Name}</h1>

                {productNames[1] && <p className="product-grp-1">{productNames[1].Name}</p>}
                {productNames[2] && <p className="product-grp-2">{productNames[2].Name}</p>}
                <div className="product-price">
                    <span className={"product-price-value " +
                        (activeProduct.ListPrice !== activeProduct.Price
                            ? "product-price-discounted"
                            : "")}>
                        {navigation.isD2C
                            ? activeProduct.PriceFormatted
                            : activeProduct.PriceExFormatted} {activeProduct.Currency}&nbsp;
                    </span>
                    {activeProduct.ListPrice !== activeProduct.Price &&
                        <React.Fragment>
                            <span className="product-listprice-value ">
                                {navigation.isD2C
                                    ? activeProduct.ListPriceFormatted
                                    : activeProduct.ListPriceExFormatted} {activeProduct.Currency}&nbsp;
                            </span>
                        </React.Fragment>
                    }
                </div>
            </HideIfOnScreen>
            <div className="child-container">{props.children}</div>
        </div>
        : null }</React.Fragment>;
};

//const MobileFloatingContainer = props => {
//    const { navigation, itemList } = props;
//    const myRef = useRef();
//    if (navigation.viewPortWidth > 991 || !itemList) {
//        return null;
//    }

//    return <div ref={myRef}>
//        <div className="mobile-floating-wrapper">
//            {itemList.map((item) => {
//                return <div key={item.Key}>{item.Value}</div>;
//            })}
//        </div>
//    </div>;
//};

@inject("store")
@observer
export class ProductDetails extends React.Component {
    constructor(props) {
        super(props);

        this.closeProductCard = this.closeProductCard.bind(this);
        this.increaseQuantities = this.increaseQuantities.bind(this);

        this.getProductUrl = this.getProductUrl.bind(this);
        this.openProductDialog = this.openProductDialog.bind(this);

        this.setActiveProductVariant = this.setActiveProductVariant.bind(this);
        //this.addToBasket = this.addToBasket.bind(this);

        this.toggleMoreInfo = this.toggleMoreInfo.bind(this);
        this.updateProductState = this.updateProductState.bind(this);
        this.openSizeChart = this.openSizeChart.bind(this);
        this.accordionCallback = this.accordionCallback.bind(this);
        this.getVariantFilter = this.getVariantFilter.bind(this);

        this.replaceAll = this.replaceAll.bind(this);
        this.convertToHtml = this.convertToHtml.bind(this);
        //this.handleFloatingContainer = this.handleFloatingContainer.bind(this);


        //debugger;
        this.state = {
            adding: [],
            productId: this.props.store.navigation.singleProduct
                ? this.props.store.navigation.singleProduct.ProductId
                : null,
            added: false,
            sku: this.props.store.navigation.singleProduct
                ? this.props.store.navigation.singleProduct.Sku
                : null,

            variantSku: null,
            //productUrl: this.props.store.navigation.mainRouter.location.pathname,
            productImage: null,

            moreInfo: {
                description: false,
                declaration: false,
                b2bInfo: false
            },

            selectedSku: null,
            selectedVariantSku: null,


            filter: {Groups: this.getVariantFilter(), VariantSku: null},

            primaryImage: null
            //images: []
        };

    }


    accordionCallback(name, state) {
        //console.log("callback", name, state);

    }

    SortOrder(a, b) {
        if (a.SortOrder < b.SortOrder) {
            return -1;
        }
        if (a.SortOrder > b.SortOrder) {
            return 1;
        }
        return 0;
    }

    //handleFloatingContainer(event) {
    //    if (!event || !event.Action || !event.Item) {
    //        return;
    //    }

    //    if (!event.Item.Key || !event.Item) {
    //        return;
    //    }
    //    let temp = this.state.floatingContainer;
    //    if (!temp) {
    //        temp = [];
    //    }

    //    if (event.Action === "add" && event.Item.Value) {
    //        // add item if container if not exists
    //        if (!temp.find(x => x.Key === event.Item.Key)) {
    //            temp.push(event.Item);
    //            temp.sort(this.SortOrder);
    //            this.setState({ floatingContainer: temp });
    //        }
    //    } else if (event.Action === "remove") {
    //        debugger;
    //        let index = this.state.floatingContainer.map(e => e.Key).indexOf(event.Item.Key);
    //        if (index > -1) {
    //            temp.slice(index, 1);
    //            this.setState({ floatingContainer: temp });
    //        }
    //    }
    //}

    toggleMoreInfo(toggleItem, reset) {
        //console.log("toggleMoreInfo");
        let currentState = reset
            ? {
                description: false,
                declaration: false,
            }
            : this.state.moreInfo;

        currentState[toggleItem] = !currentState[toggleItem];


        this.setState({moreInfo: currentState});
    }

    closeProductCard(e) {
        e.preventDefault();
        this.props.onClose(e);
    }

    getProductUrl(product, variantOptions) {
        return this.props.store.navigation.getProductUrl(product, variantOptions);
    }

    openProductDialog(e, product, listIndex, variantOptions) {

        if (e) {
            e.preventDefault();
        }

        //console.log("openProductDialog", product, variantOptions);
        this.props.store.navigation.openProductDialog(product, {listIndex: -1, variantOptions: variantOptions});
    }

    openSizeChart(e) {
        e.preventDefault();
        this.props.store.navigation.openSizeChart();
    }


    increaseQuantities(e, changes) {
        e.preventDefault();
        clearTimeout(this.timer);
        this.setState({adding: changes});

        const orderStore = this.props.store.order;
        // this.timer = setTimeout(() => {
        //         this.setState({adding: [], added: true});
        //     },
        //     1000);
        orderStore.increaseQuantities(changes).then(result => {
            //clearTimeout(this.timer);
            this.setState({adding: [], added: true});
            this.timer = setTimeout(() => {
                this.setState({added: false});
            }, 2000);

        });
    }

    setActiveProductVariant(e, productVariant, productUrl, productImage, selectedSizeValue) {
        e.preventDefault();


        const toBeSet = {
            selectedSku: productVariant.Sku,
            selectedVariantSku: this.state.selectedVariantSku === productVariant.VariantSku ? null : productVariant.VariantSku,
            selectedSizeValue: this.state.selectedVariantSku === productVariant.VariantSku ? null : selectedSizeValue,
            productImage: this.state.selectedVariantSku === productVariant.VariantSku ? null : productImage,
            //productUrl: this.state.selectedVariantSku === productVariant.VariantSku ? null : productUrl,
            added: false,
            adding: []
        };

        console.debug("toBeSet", productVariant, toBeSet);
        this.setState(toBeSet);
    }

    // addToBasket(e) {
    //     const orderStore = this.props.store.order;
    //
    //     const changes =
    //         [
    //             {
    //                 Sku: this.state.selectedSku,
    //                 VariantSku: this.state.selectedVariantSku,
    //                 AddQuantity: 1,
    //                 ProductUrl: this.state.productUrl,
    //                 ProductImage: this.state.productImage
    //             }
    //         ];
    //
    //     this.increaseQuantities(e, changes);
    // }

    componentDidMount() {
        //this.props.store.analytics.productDetailView(this.props.store.navigation.singleProduct);
        this.updateProductState();
        objectFitImages('.image-gallery-image');
    }

    analyticsViewProduct() {
        // Analytics
        var activeProduct = this.props.store.navigation.singleProduct;

        if (this.state.filter.Groups != null) {
            for (var obj of this.state.filter.Groups) {
                const tempProduct = activeProduct.Variants.find(x => x.PropertyByKey(obj.GroupKey) === obj.GroupValue);
                if (tempProduct != null) {
                    activeProduct = tempProduct;
                } else {
                    this.openProductDialog(null, product, -1, activeProduct.Variants[0].UrlSlug);
                }
            }
        } else {
            activeProduct = activeProduct.Variants[0];
        }

        const primaryImageUrl = (activeProduct && activeProduct.ProductMedia.length > 0)
            ? activeProduct.ProductMedia[0].FileData
            : activeProduct.PrimaryImageUrl
                ? activeProduct.PrimaryImageUrl
                : "{ \"src\": \"/dist/img/missing_image.jpg\"}";


        const packshot = activeProduct ? activeProduct.ProductMedia.filter(x => {
            return x.Packshot
        }) : null;
        let packshotIndex = 0;

        // Check if first packshot is main image, try get second packshot to use as hove image
        if (packshot && packshot.length > 1 && primaryImageUrl === packshot[packshotIndex].FileData) {
            packshotIndex = 1;
        }

        const currentImageUrl = packshot && packshot[packshotIndex] ? packshot[packshotIndex].FileData : primaryImageUrl;
        const imageWidth = 720;
        const imageHeight = imageWidth;

        this.props.store.analytics.productDetailView(activeProduct, this.props.store.navigation.baseUrl + getBoxPadUrl(currentImageUrl, imageWidth, imageHeight, this.props.store.navigation.ImageFormat, "ffffff").url);
    }

    renderItem(item) {
        return (<div className='image-gallery-image '>
            {/*<img src={item.original} style={{ maxHeight: '90vh', maxWidth: '100vw', objectFit: 'scale-down', fontFamily: "'object-fit: scale-down'" }} />*/}
            <img src={item.original}/>

        </div>);
    }

    componentWillReact() {
        const navigation = this.props.store.navigation;
        const product = navigation.singleProduct;
        if (typeof window === 'undefined') return;

        const {sku, variant} = navigation.getSkuFromLocation();
        //console.log("componentWillReact - ", sku, "this.props.container", this.props.container, (typeof this.props.container));
        if (typeof this.props.container !== "undefined" && product && (this.state.sku !== sku)) {
            //console.log("run updateProductState")
            this.updateProductState();
            if(this.props.container && this.props.container.firstChild) {
                //this.props.container.firstChild.scrollTop = 0;
                this.props.container.firstChild.scrollTo({top:0, behavior:"smooth"});
                
            }
            
        }

    }


    getVariantFilter() {
        const navigation = this.props.store.navigation;
        const product = navigation.singleProduct;
        const {sku, variant} = navigation.getSkuFromLocation();
        const splittedVariants = variant && variant.split(":");

        if (variant && variant.indexOf("=") > -1) {
            const groups = splittedVariants.map((kv, groupIndex) => {
                const d = kv.split("=");
                return {
                    GroupKey: d[0] + "Id",
                    GroupValue: d[1]
                };
            });

            return groups;
        }

        return null;
    }

    updateProductState() {
        const navigation = this.props.store.navigation;
        const product = navigation.singleProduct;

        const {sku} = navigation.getSkuFromLocation();
        //const productUrl = ;// navigation.mainRouter.location.pathname;

        if (!product) {
            return;
        }

        this.setState({
            productId: product.ProductId,
            sku: sku,
            //variant: variant,     // These comes from url
            variantSku: null,
            added: false, adding: [],
            selectedSku: sku,   // This is local to component
            //selectedVariantSku: this.state.variantSku, // This is local to component 
            //  productUrl: productUrl,
            productImage: null,
            filter: {Groups: this.getVariantFilter(), VariantSku: null},
            floatingContainer: []
        });


        this.analyticsViewProduct();
    }

    hasProperty(product, properties, matchName) {
        let property = properties.find(x => x.key.indexOf(matchName) > -1);
        if (!property) return false;
        return property.value && property.value.length > 0
    }

    renderDetails(product, properties, matchName) {
        const dictionary = this.props.store.navigation.dictionary;
        var property = properties.find(x => x.key.indexOf(matchName) > -1);
        if (!property) return null;
    
        
        
        if (Array.isArray(property.value)) {
            return (
                <ul>
                    {property.value.map((pv, pvIndex) => {
                        return (<li key={pvIndex}>
                            {dictionary[pv] || pv}
                        </li>);
                    })}
                </ul>
            );
        } else if (property.value.indexOf(",") > -1) {
            return property.value;
            // return (
            //     <ul>
            //         {property.value.split(",").map((pv, pvIndex) => {
            //             return (<li key={pvIndex}>
            //                 {dictionary[pv] || pv}
            //             </li>);
            //         })}
            //     </ul>
            // );
        } else {
            return property.value;
        }
    }

    renderNeedToKnow(product, properties) {

        const definition = this.props.store.navigation.definitions.find(x => x.Id === product.ProductDefinition);
        let propertiesWithData = [];
        if (definition) {
            propertiesWithData = definition.DisplayFields.filter(x => properties.find(y => y.key === x.Name && y.value && y.value !== ""));
        }

        const nrOfColumns = 2;
        const totalItems = propertiesWithData.length;
        const itemsPerColumn = Math.ceil(totalItems / nrOfColumns);
        const columns = [];
        let columnIndex = 0;
        let currentColumn = [];

        
        for (var i = 0; i < totalItems; i++) {

            if (columnIndex === 0) {
                currentColumn = [];
                columns.push(currentColumn);
            }

            currentColumn.push(propertiesWithData[i]);

            columnIndex++;

            if (columnIndex >= itemsPerColumn) {
                columnIndex = 0;
            }
        }

        //console.log("columns", columns);

        return (
            <div className="row">
                {columns.map((column, columnIndex) => {
                    return (
                        <div key={columnIndex}
                             className="col">
                            <ul>

                                {column.map(field => {
                                    const fieldValue = properties.find(x => x.key === field.Name);
                                    return (
                                        <li key={field.Name}
                                            className=""
                                        >
                                            <label>{field.DisplayName}</label>
                                            {fieldValue && fieldValue.value}

                                        </li>
                                    );

                                })}
                            </ul>
                        </div>);
                })}
            </div>
        );
    }

    convertToHtml(input) {
        return this.replaceAll(this.replaceAll(this.replaceAll(this.replaceAll(input, "\r\n", "</br>"), "\n\r", "</br>"), "\n", "</br>"), "\r", "</br>");
    }

    replaceAll(str, find, replace) {
        return str.replace(new RegExp(find, 'g'), replace);
    }

    render() {

        const serverRender = typeof window === 'undefined';
        const navigation = this.props.store.navigation;
        const productFamily = navigation.singleProduct;

        const {sku, variant} = navigation.getSkuFromLocation(); // Trigger to re-render on sku/variant change


        if (productFamily == null) {
            return null;
        }

        //console.log("this.state", this.state);

        const retina = isRetina();
        const imageWidthDefault = 1440;
        const imageHeightDefault = imageWidthDefault;// * 1.499;

        const imageWidth = imageWidthDefault / (retina ? 1 : 2);
        const imageHeight = imageWidth;

        const thumbWidthDefault = 138;
        const thumbWidth = thumbWidthDefault / (retina ? 1 : 2);
        const thumbHeight = thumbWidth;
        let images = [];


        //const filteredVariantsAndImages = product.FilteredVariants((this.state.filter && this.state.filter.Groups) || []);
        //filteredVariantsAndImages.Images && filteredVariantsAndImages.Images.forEach(image => {
        //    images.push({
        //        fileData: image.FileData,
        //        default: getBoxPadUrl(image.FileData, imageWidthDefault, imageHeightDefault, navigation.ImageFormat, "ffffff").url,
        //        original: getBoxPadUrl(image.FileData, imageWidth, imageHeight, navigation.ImageFormat, "ffffff").url,
        //        zoom: getBoxPadUrl(image.FileData, 2000, 3000, navigation.ImageFormat, "ffffff").url,
        //        thumbnail: getBoxPadUrl(image.FileData, thumbWidth, thumbHeight, navigation.ImageFormat, "ffffff").url
        //    });
        //});

        //const filteredVariants = filteredVariantsAndImages.Variants || [];


        let activeProduct = productFamily;


        //console.log("render-state", this.state);

        if (this.state.filter.Groups != null) {
            for (var obj of this.state.filter.Groups) {
                const tempProduct = activeProduct.Variants.find(x => x.PropertyByKey(obj.GroupKey) === obj.GroupValue);
                if (tempProduct != null) {
                    activeProduct = tempProduct;
                } else {
                    this.openProductDialog(null, productFamily, -1, activeProduct.Variants[0].UrlSlug);
                }
            }
        } else {
            // Try find by Sku
            const p = productFamily.Variants.find(x => x.Sku === sku);
            if (p != null) {
                activeProduct = p;
            } else {
                activeProduct = activeProduct.Variants[0];
            }
        }

        /// Try to set activeVariant if possible from state.selectedSku + state.selectedVariantSku
        let activeVariant = null;
        if (activeProduct && activeProduct.Variants) {
            activeVariant = activeProduct.Variants.find(x => x.Sku === this.state.selectedSku && (x.ProductType === 1 || x.ProductType === 2));
        }

        if (activeVariant == null) {
            activeVariant = activeProduct;
        }

        //console.log("productFamily", productFamily, "activeProduct", activeProduct, "activeVariant", activeVariant);

        const orderlines = this.props.store.order.activeOrder && this.props.store.order.activeOrder.OrderLinesBySku(activeVariant.Sku, activeVariant.VariantSku);
        const quantity = orderlines && orderlines.length > 0 ? orderlines[0].Quantity : 0;

        const packSize = parseInt(activeVariant.PropertyByKey("PackSize"));
        const increments = isNaN(packSize) ? 1 : packSize;


        const productNames = [];
        productNames.push({Name: activeVariant.DisplayName, Key: ""});

        const brand = activeVariant.PropertyByKey("f_Brand");
        const brandName = (brand && Array.isArray(brand) && brand.length > 0)
            ? brand[0]
            : null;

        if (brandName) {
            productNames.push({Name: brandName, Key: "Brand"});
        }


        images.push({
            original: getBoxPadUrl(activeVariant.PrimaryImageUrl, imageWidth, imageHeight, navigation.ImageFormat, "ffffff").url,
            thumbnail: getBoxPadUrl(activeVariant.PrimaryImageUrl, thumbWidth, thumbHeight, navigation.ImageFormat, "ffffff").url,
            zoom: getBoxPadUrl(activeVariant.PrimaryImageUrl, imageWidthDefault, imageHeightDefault, navigation.ImageFormat, "ffffff").url,
            alt: (navigation.dictionary.ImageOf || 'Bild på ') + activeVariant.DisplayName
            //original: activeProduct.PrimaryImageUrl
        })
        //console.log("images", images);
        activeVariant.ProductMedia.forEach(image => {
            images.push({
                //fileData: image.FileData,
                original: getBoxPadUrl(image.FileData, imageWidth, imageHeight, navigation.ImageFormat, "ffffff").url,
                zoom: getBoxPadUrl(image.FileData, imageWidthDefault, imageHeightDefault, navigation.ImageFormat, "ffffff").url,
                thumbnail: getBoxPadUrl(image.FileData, thumbWidth, thumbHeight, navigation.ImageFormat, "ffffff").url,
            });
        });
        var startIndex = 0;
        // if (images.length > 3 && navigation.viewPortWidth > 991) {
        //     startIndex = 2;
        // }

        const packShotImage = images.length > 0 ? images[0].fileData : null;

        //images = ImageSorter(images);

        const primaryImage = images.length > 0
            ? images[0].original
            : "/dist/img/missing_image.jpg";
        // : activeVariant
        //     ? !activeVariant.PrimaryImageUrl || activeVariant.PrimaryImageUrl === ""
        //         ? "{ \"src\": \"/dist/img/missing_image.jpg\"}"
        //         : activeVariant.PrimaryImageUrl //getBoxPadUrl(product.PrimaryImageUrl, imageWidth, imageHeight, navigation.ImageFormat, "ffffff")
        //     : null;


        //const primaryImageUrl = navigation.baseUrl + "/" + getBoxPadUrl(primaryImage, imageWidthDefault, imageHeightDefault, navigation.ImageFormat, "ffffff").url;
        const primaryImageUrl = navigation.baseUrl + primaryImage;


        const properties = [];
        for (let key of Object.keys(activeVariant.Properties)) {
            properties.push({key: key, value: activeVariant.Properties[key]});
        }

        let brandLink = properties.find(p => p.key === "BrandLink"); // const brandLink = properties.find(p => p.key === "BrandLink")?.value // this fails in react.net
        if (brandLink) {
            brandLink = brandLink.value;
        } else {
            brandLink = undefined;
        }


        const titleRef = React.createRef();

        const activeProductsAndRelatedVariants = [activeProduct, ...activeProduct.Variants.filter(x => x.ProductType === 1 || x.ProductType === 2)];
        const otherVariants = activeProduct.Variants.filter(x => x.ProductType === 3);

        //console.log("activeProductsAndVariants", activeProductsAndRelatedVariants);

        const stockStatus = activeVariant.PropertyByKey("StockStatus");
        let inStock = true;
        let textAddButton = "Lägg till";
        let addButtonEnabled = true;
        switch (stockStatus) {
            case "PreBook":
                if (navigation.isD2C) {
                    textAddButton = "Kommer snart";
                    addButtonEnabled = false;
                    inStock = false;
                } else {
                    textAddButton = "Förboka";
                }

                break;
            case  "OutOfStock":
                textAddButton = "Slut för säsong";
                addButtonEnabled = false;
                inStock = false;
                break;
            case "TemporaryOutOfStock":
                textAddButton = "Kommer snart";
                addButtonEnabled = false;
                inStock = false;
                break;
        }
        
        return (
            <React.Fragment>
                <Helmet>
                    <title>{productNames.filter(item => item.Name != null).map(item => item.Name.trim()).join(" - ")}</title>
                    <meta name="description" content={activeVariant.ShortDescription}/>
                    <meta name="keywords" content=""/>

                    <meta property="og:title"
                          content={productNames.filter(item => item.Name != null).map(item => item.Name.trim()).join(" - ")}/>
                    <meta property="og:description" content={activeVariant.ShortDescription}/>
                    <meta property="og:image" content={primaryImageUrl}/>
                    <meta property="og:image:width" content={primaryImageUrl && imageWidthDefault}/>
                    <meta property="og:image:height" content={primaryImageUrl && imageHeightDefault}/>
                </Helmet>
                <StructuredDataProduct product={activeVariant} images={images.map(i => i.zoom)} navigationStore={navigation} inStock={inStock}/>

                <button className="close"
                        onClick={(e) => {
                            this.closeProductCard(e);
                        }}
                >
                    <FontAwesomeIcon icon={["fas", "times"]}
                                     size="sm"
                                     className={""}
                    />
                    <span>Stäng</span>

                </button>


                <div className="product-dialog-inner">
                    <div className="product-details container-fluid">
                        <div className="row product-details-inner">
                            {navigation.viewPortWidth <= 768 ? <div
                                className="col-lg-7 product-image product-column">
                                {(navigation.viewPortWidth <= 991 && activeVariant.Ads && activeVariant.Ads.length > 0) &&
                                    <span className="product-card-ad" style={
                                        activeVariant.Ads[0].Colour !== "" ? {backgroundColor: activeVariant.Ads[0].Colour} : {}}><span
                                        className="text">{
                                        activeVariant.Ads[0].Text}</span></span>
                                }
                                {images &&
                                    <IComImageSlider images={images} mobile={true} showThumbnails={false} showBullets={true}
                                                     infinite={true} startIndex={startIndex}
                                                     thumbnailPosition={"bottom"}
                                    />}
                            </div> : <div
                                className="col-lg-7 product-image product-column desktop-slides">{(activeProduct.Ads && activeProduct.Ads.length > 0) &&
                                <span className="product-card-ad" style={
                                    activeProduct.Ads[0].Colour !== "" ? {backgroundColor: activeProduct.Ads[0].Colour} : {}}><span
                                    className="text">{
                                    activeProduct.Ads[0].Text}</span></span>
                            }
                                {images && <IComImageSlider images={images} showThumbnails={true} showNav={false}
                                                            showBullets={false} infinite={true}
                                                            thumbnailPosition={"bottom"}
                                                            startIndex={startIndex}/>}
                            </div>}

                            {/*<div className="col-xl-8 col-lg-7 product-image product-column">*/}
                            {/*    <IComImageMap images={images}/>*/}
                            {/*</div>*/}
                            <div className="col-lg-5 product-info product-column">
                                <div className="product-info-inner">
                                    {productNames[1] && <div className="product-brand">{brandLink ? <a href={brandLink} onClick={e=>  { e.preventDefault(); navigation.navigateToSiteUrl(null, brandLink, null, null, null, "");return false;} }>{productNames[1].Name}</a> : productNames[1].Name }</div> }
                                    <h1 className="product-name mb-3">{productNames[0].Name}</h1>
                                    <div className="product-price mb-3 mb-lg-5" ref={titleRef}>

                                        {!activeVariant.ComingSoon && activeVariant.InStock && activeVariant.Price > 0 &&
                                            <div className="product-edit-quantities">
                                                <QuantityEdit
                                                    key={this.state.selectedSku + "_" + this.state.selectedVariantSku}
                                                    orderStore={this.props.store.order}
                                                    sku={this.state.selectedSku}
                                                    variantSku={this.state.selectedVariantSku}
                                                    quantity={quantity}
                                                    increments={increments}
                                                    // useTextAddButton={true}
                                                    textAddButton={textAddButton}
                                                    disabled={!addButtonEnabled}
                                                    productUrl={this.getProductUrl(activeVariant, activeVariant.UrlSlug)}
                                                />
                                            </div>
                                        }
                                        <div className={"product-price-value " +
                                            (activeVariant.ListPrice !== activeVariant.Price
                                                ? "product-price-discounted"
                                                : "")}>

                                            {navigation.isD2C
                                                ? activeVariant.PriceFormatted
                                                : activeVariant.PriceExFormatted} {activeVariant.Currency}&nbsp;

                                        </div>
                                        {activeVariant.ListPrice !== activeVariant.Price &&
                                            <React.Fragment>
                                                <div className="product-listprice-value">
                                                    {navigation.isD2C
                                                        ? activeVariant.ListPriceFormatted
                                                        : activeVariant.ListPriceExFormatted} {activeVariant.Currency}&nbsp;
                                                </div>
                                            </React.Fragment>
                                        }


                                    </div>
                                    {/*<YotpoContext>*/}
                                    {/*    <YotpoProductStarts product={activeProduct} load={true} />*/}
                                    {/*</YotpoContext>*/}
                                    {activeVariant.ShortDescription &&
                                        <div className="product-shortdescription mb-3 mb-lg-5"
                                             dangerouslySetInnerHTML={{__html: this.convertToHtml(activeVariant.ShortDescription)}}
                                        >

                                        </div>
                                    }


                                    <div className={"product-details-accordions mb-3 mb-lg-5"}>
                                        <Accordion
                                            key={"description"}
                                            className='product-details-accordion'
                                            transitionDuration={250}
                                            selectedIndex={(this.state.moreInfo && this.state.moreInfo.description) ? 0 : -1}
                                            name="description"
                                            callback={this.accordionCallback}
                                        >
                                            <div
                                                data-header={navigation.dictionary.ProductDescription || 'Läs mer'}
                                                data-headerclass="product-button-details-mobile">
                                                <div className="product-details-accordion-content">
                                                    <div
                                                        dangerouslySetInnerHTML={{__html: activeVariant.LongDescription}}></div>
                                                    {this.renderDetails(activeProduct, properties, "ProductInformation")}
                                                </div>

                                            </div>
                                        </Accordion>

                                        <Accordion className='product-details-accordion'
                                                   key={"declaration"}
                                                   transitionDuration={250}
                                                   selectedIndex={(this.state.moreInfo && this.state.moreInfo.declaration) ? 0 : -1}
                                                   name="declaration"
                                                   callback={this.accordionCallback}
                                        >
                                            <div
                                                data-header={navigation.dictionary.DeclarationOfContent || 'Innehåll'}
                                                data-headerclass="product-button-details-mobile">
                                                <div className="product-details-accordion-content"
                                                     dangerouslySetInnerHTML={{__html:this.renderDetails(activeVariant, properties, "Content")}}
                                                >
                                                </div>
                                            </div>
                                        </Accordion>

                                        {!this.props.store.navigation.isD2C ? <Accordion className='product-details-accordion'
                                                                                         key={"b2bInfo"}
                                                                                         transitionDuration={250}
                                                                                         selectedIndex={(this.state.moreInfo && this.state.moreInfo.b2bInfo) ? 0 : -1}
                                                                                         name="b2bInfo"
                                                                                         callback={this.accordionCallback}
                                        >
                                            <div
                                                data-header={'Artikelinformation'}
                                                data-headerclass="product-button-details-mobile">
                                                <div className="product-details-accordion-content">

                                                    <div
                                                        dangerouslySetInnerHTML={{__html: activeVariant.PropertyByKey("b2b_ResellerDescription")}}></div>


                                                </div>

                                            </div>
                                        </Accordion> : null}

                                    </div>

                                    {otherVariants && otherVariants.length > 1 && !productFamily.Preload &&

                                        <div className={"mb-3 mb-lg-5"}>
                                            <div className="product-choosevariant mb-1">
                                                Välj variant
                                            </div>

                                            <div className={"product-variant-grid"}
                                                 style={{gridTemplateColumns: "repeat(2, minmax(50px, 1fr))"}}>
                                                {otherVariants.map(variant => {

                                                    // const marketName = "US";
                                                    // let sizeProperty = Object.keys(variant.Properties)
                                                    //     .find(x => x.indexOf("Size" + marketName) > -1);
                                                    //
                                                    // // Fallback
                                                    // sizeProperty = sizeProperty ? sizeProperty :
                                                    //     Object.keys(variant.Properties)
                                                    //         .find(x => x.indexOf("Size") > -1);
                                                    //
                                                    //
                                                    let sizeValue = variant.PropertyByKey("Size");

                                                    // Fallback -> Name
                                                    sizeValue = sizeValue ? sizeValue : variant.DisplayName;
                                                    //console.log("selected", this.state.selectedSku, variant.Sku, this.state.selectedVariantSku, variant.VariantSku);
                                                    const cn = classnames("product-button-purchase",
                                                        {
                                                            'active': (this.state.selectedSku === variant.Sku && this.state.selectedVariantSku === variant.VariantSku)
                                                        });

                                                    return (
                                                        <button
                                                            key={"variant_" + variant.Guid}
                                                            disabled={!variant.InStock}
                                                            className={cn}
                                                            onClick={(e) => this.setActiveProductVariant(e, variant, navigation.mainRouter.location.pathname, packShotImage, sizeValue)}
                                                        >
                                                            {sizeValue}
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        </div>

                                    }


                                    {activeProductsAndRelatedVariants && activeProductsAndRelatedVariants.length > 1 && !productFamily.Preload &&
                                        // activeProduct.Variants.length > 0 && !activeProduct.ComingSoon && !productFamily.Preload && activeProduct.AllowOrdering && activeProduct.HasVariants && activeProduct.Price > 0 &&
                                        <div className={"mb-3 mb-lg-5"}>
                                            <div className="product-choosevariant mb-1">
                                                Välj förpackningstorlek
                                            </div>
                                            {/*<MobileFloatingWrapper navigation={navigation} productNames={productNames}*/}
                                            {/*                       activeProduct={activeProduct}*/}
                                            {/*                       hideTitleIfRefOnScreen={titleRef}*/}
                                            {/*                       selectedSizeValue={this.state.selectedSizeValue}>*/}

                                                <div className={"product-variant-grid"}
                                                     style={{gridTemplateColumns: "repeat(2, minmax(50px, 1fr))"}}>
                                                    {activeProductsAndRelatedVariants.map(variant => {

                                                        // const marketName = "US";
                                                        // let sizeProperty = Object.keys(variant.Properties)
                                                        //     .find(x => x.indexOf("Size" + marketName) > -1);
                                                        //
                                                        // // Fallback
                                                        // sizeProperty = sizeProperty ? sizeProperty :
                                                        //     Object.keys(variant.Properties)
                                                        //         .find(x => x.indexOf("Size") > -1);
                                                        //
                                                        //
                                                        let sizeValue = variant.PropertyByKey("PackageDescription");

                                                        // Fallback -> Name
                                                        sizeValue = sizeValue ? sizeValue : variant.DisplayName;
                                                        //console.log("selected", this.state.selectedSku, variant.Sku, this.state.selectedVariantSku, variant.VariantSku);
                                                        const cn = classnames("product-button-purchase",
                                                            {
                                                                'active': (this.state.selectedSku === variant.Sku && this.state.selectedVariantSku === variant.VariantSku)
                                                            });

                                                        return (
                                                            <button
                                                                key={"variant_" + variant.Guid}
                                                                disabled={!variant.InStock}
                                                                className={cn}
                                                                onClick={(e) => this.openProductDialog(e, variant, -1, variant.UrlSlug)}
                                                            >
                                                                {sizeValue}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                                {/*<button*/}
                                                {/*    className={"product-button-addtobasket " + (this.state.selectedSku ? "" : "disabled")}*/}
                                                {/*    onClick={this.addToBasket}*/}
                                                {/*    disabled={this.state.selectedSku === null}*/}
                                                {/*>*/}

                                                {/*    {this.state.adding && this.state.adding.length > 0*/}
                                                {/*        ? <React.Fragment><FontAwesomeIcon icon={["fas", "spinner"]*/}
                                                {/*        } className="quantity-add"*/}
                                                {/*                                           spin/>&nbsp;{navigation.dictionary.AddingToCart}*/}
                                                {/*        </React.Fragment>*/}
                                                {/*        : this.state.added*/}
                                                {/*            ?*/}
                                                {/*            <React.Fragment><FontAwesomeIcon*/}
                                                {/*                icon={["fas", "check-circle"]}*/}
                                                {/*                className="quantity-add"/> &nbsp;{navigation.dictionary.AddedToCart}*/}
                                                {/*            </React.Fragment>*/}
                                                {/*            : this.state.selectedSku*/}
                                                {/*                ? navigation.dictionary.AddToCart*/}
                                                {/*                : navigation.dictionary.ChooseSize*/}
                                                {/*    }*/}
                                                {/*</button>*/}
                                            {/*</MobileFloatingWrapper>*/}
                                            {activeProduct.PropertyByKey("BundleInfo") &&
                                                <div className="product-bundle-info"
                                                     dangerouslySetInnerHTML={{__html: navigation.marketSettings.ProductCardUSP + activeProduct.PropertyByKey("BundleInfo")}}></div>}
                                            {!activeProduct.PropertyByKey("BundleInfo") && navigation.marketSettings.ProductCardUSP &&
                                                <div className="product-bundle-info"
                                                     dangerouslySetInnerHTML={{__html: navigation.marketSettings.ProductCardUSP}}></div>}

                                        </div>
                                    }


                                    {!productFamily.Preload &&
                                        <React.Fragment
                                        >


                                            {productFamily.Variants.length > 1 &&
                                                [<div key={"div-header"} className="product-choosevariant mb-1">
                                                    Fler sorter
                                                </div>,
                                                    <div key={"div-variants"} className="product-variant-grid-large" style={{paddingBottom: "0px"}}>
                                                        {productFamily.Variants.map((sibling, index) => {
                                                            let variantPrimaryImageUrl = sibling.PrimaryImageUrl;
                                                            return (
                                                                <a key={"sibling_" + sibling.Sku}
                                                                   className={sibling.Sku === activeProduct.Sku ? "active" : ""}
                                                                   href={(sibling.ComingSoon ? null : this.getProductUrl(productFamily, sibling.UrlSlug))}
                                                                   title={sibling.DisplayName}
                                                                   onClick={(e) => {
                                                                       if (sibling.ComingSoon) return;
                                                                       this.openProductDialog(e, productFamily, -1, sibling.UrlSlug);
                                                                   }} style={{overflow: "hidden", textOverflow: "ellipsis"}}>
                                                                    <img
                                                                        height={160}
                                                                        width={160}
                                                                        // alt={altText.filter(item => item.Name != null).map(item => item.Name.trim()).join(" - ")}
                                                                        className={"product-siblings"}
                                                                        src={variantPrimaryImageUrl
                                                                            ? getBoxPadUrl(variantPrimaryImageUrl, 160, 160, navigation.ImageFormat, "ffffff").url
                                                                            //getCropUrl(sibling.PrimaryImageUrl, "Default", 80, navigation.ImageFormat, "f6f6f6", 80).cropUrl
                                                                            : "/dist/img/missing_image.jpg"
                                                                        }/><br/>
                                                                    {sibling.ComingSoon ? <span style={{
                                                                        padding: "5px",
                                                                        //position: "absolute",
                                                                        width: "100%",
                                                                        color: "#fff",
                                                                        //left: 0,
                                                                        //bottom: "-20px",
                                                                        backgroundColor: navigation.dictionary.ComingSoonColor
                                                                    }}>{navigation.dictionary.ComingSoon}</span> : <span
                                                                        style={{
                                                                            padding: "5px",
                                                                            //position: "absolute",
                                                                            width: "100%",
                                                                            color: "#000",
                                                                            //left: 0,
                                                                            //bottom: "-20px"
                                                                        }}>{sibling.DisplayName}</span>}
                                                                </a>

                                                            );
                                                        })}

                                                    </div>]
                                            }
                                        </React.Fragment>
                                    }
                                    {/*<div>*/}
                                    {/*    {activeProduct.Siblings && activeProduct.Siblings.map((sibling, siblingPosition) => (*/}
                                    {/*        <a key={"sibling_" + sibling.Sku}*/}
                                    {/*           href={this.getProductUrl(sibling)} onClick={(e) => {*/}
                                    {/*            this.openProductDialog(e, sibling, siblingPosition + 1);*/}
                                    {/*        }}>*/}
                                    {/*            <img*/}
                                    {/*                height={160}*/}
                                    {/*                width={160}*/}
                                    {/*                alt={sibling.DisplayName}*/}
                                    {/*                className={"product-siblings mr-2 mb-2 " + (sibling.Sku === productFamily.Sku ? "active" : "")}*/}
                                    {/*                src={sibling.PrimaryImageUrl !== ""*/}
                                    {/*                    ? getBoxPadUrl(sibling.PrimaryImageUrl, 160, 160, navigation.ImageFormat, "ffffff").url*/}
                                    {/*                    //getCropUrl(sibling.PrimaryImageUrl, "Default", 80, navigation.ImageFormat, "f6f6f6", 80).cropUrl*/}
                                    {/*                    : "/dist/img/missing_image.jpg"*/}
                                    {/*                }/>*/}
                                    {/*        </a>*/}
                                    {/*    ))}*/}

                                    {/*</div>*/}


                                    {/*{!activeProduct.ComingSoon && (!productFamily.Preload && (!activeProduct.AllowOrdering || !activeProduct.HasVariants || activeProduct.Price === 0)) &&*/}
                                    {/*    <a className="product-button-addtobasket"*/}
                                    {/*       href={navigation.marketSettings.StoreLocatorUrl}*/}
                                    {/*       style={{textAlign: "center"}}*/}
                                    {/*    >*/}
                                    {/*        {navigation.dictionary.FindAStore}*/}
                                    {/*    </a>}*/}


                                    {/*{!activeProduct.ComingSoon && (!productFamily.Preload && !activeProduct.HasVariants && activeProduct.InStock && activeProduct.Price > 0) &&*/}
                                    {/*    <button*/}
                                    {/*        className="product-button-purchase"*/}
                                    {/*        onClick={(e) => this.increaseQuantities(e,*/}
                                    {/*            [*/}
                                    {/*                {*/}
                                    {/*                    Sku: activeProduct.Sku,*/}
                                    {/*                    VariantSku: null,*/}
                                    {/*                    AddQuantity: 1,*/}
                                    {/*                    ProductUrl: this.props.store.navigation.mainRouter.location*/}
                                    {/*                        .pathname,*/}
                                    {/*                    ImageUrl: primaryImage*/}
                                    {/*                }*/}
                                    {/*            ])}*/}
                                    {/*    >*/}
                                    {/*        {productFamily.InStock*/}
                                    {/*            ? navigation.dictionary.AddToBasket*/}
                                    {/*            : navigation.dictionary.NotInStock}*/}

                                    {/*        /!*{product.InStock*!/*/}
                                    {/*        /!*    ? <FontAwesomeIcon icon={["fas", "shopping-bag"]} className="bag"/>*!/*/}
                                    {/*        /!*    : null}*!/*/}
                                    {/*        <span className={classnames("count", {'visible': this.state.adding})*/}
                                    {/*        }><span className="count-text">+1</span></span>*/}

                                    {/*    </button>*/}
                                    {/*}*/}


                                    {/*
                                    <div
                                        className="product-usp"
                                        dangerouslySetInnerHTML={{ __html: navigation.marketSettings.ProductCardUSP }}
                                    >

                                    </div> */}


                                    {/*<div className="product-articlenumber mb-3 mt-3">*/}
                                    {/*    {navigation.dictionary.ArticleNumber}: {activeVariant.Sku}<br/>*/}
                                    {/*</div>*/}
                                </div>

                            </div>
                            {/*<YotpoContext>*/}
                            {/*    <div className={"col-lg-12 "}>*/}
                            {/*        <h3 className="product-header"*/}
                            {/*            style={{ textAlign: "center" }}>{navigation.dictionary.Reviews || "Reviews"}</h3>*/}
                            {/*        <YotpoReviews product={activeProduct} productName={productNames[0].Name}*/}
                            {/*            primaryImageUrl={primaryImageUrl} navigation={navigation} />*/}
                            {/*    </div>*/}
                            {/*</YotpoContext>*/}
                        </div>
                    </div>


                    {/*(product.CustomerAlsoBought && product.CustomerAlsoBought.length > 0) &&
                        <div className="product-extra container-fluid">
                            <h3 className="product-header">{navigation.dictionary.CustomerAlsoBought}</h3>
                            <div>
                                <ProductGrid products={product.CustomerAlsoBought} navigation={navigation} disableLacyLoad={true} />
                            </div>
                        </div>
                    */}
                    {(productFamily.RelatedProducts && productFamily.RelatedProducts.length > 0) &&
                        <div className="related-products-container container-fluid">
                            <h3 className="product-header">{navigation.dictionary.RelatedProducts || "Mer från samma varumärke"}</h3>
                            <div className={"product-container"}>
                                {productFamily.RelatedProducts.map((product, areaIndex) => {
                                        return (
                                            <div className="grid-card" key={product.Sku}>
                                                <div className={"product-outer"}>
                                                    <div className="product-card">
                                                        <ProductCard
                                                            product={product}
                                                            disableLacyLoad={true}
                                                            orderStore={this.props.store.order}
                                                            navigation={this.props.store.navigation}
                                                            listIndex={areaIndex}
                                                            imageWidth={400}
                                                        />
                                                    </div>
                                                </div>
                                            </div>);
                                    }
                                )}


                                {/*<ProductGrid products={productFamily.RelatedProducts} navigation={navigation}*/}
                                {/*             disableLacyLoad={true}/>*/}
                            </div>
                        </div>
                    }
                    {/*<Footer/>*/}

                </div>
            </React.Fragment>
        );
    }
}

@inject("store")
@observer
export class ProductModal extends React.Component {
    //@observable product = null;

    constructor(props) {
        super(props);

        this.modalRef = React.createRef();
        this.closeProductDetails = this.closeProductDetails.bind(this);
        //this.touchMoveHandler = this.touchMoveHandler.bind(this);
        //this.touchStartHandler = this.touchStartHandler.bind(this);
        //this.isOverlayTotallyScrolled = this.isOverlayTotallyScrolled.bind(this);
        this.clientY = null;
        this.tempScrolltop = 0;
        this.timer = null;
        this.state = {
            modalOpen: this.props.store.navigation.singleProduct !== null ,
            currentSku: ""
        };
    }

    //touchMoveHandler(e) {
    //    //console.log("touch move");
    //    console.log("scrollTop", document.body.scrollTop);
    //    if (e.targetTouches.length === 1) {
    //        // detect single touch
    //    //    document.body.scrollTop = this.tempScrolltop;
    //        //this.disableRubberBand(event);
    //    }
    //    else {
    //        this.tempScrolltop= document.body.scrollTop;
    //    }

    //}

    //touchStartHandler(e) {
    //    if (e.targetTouches.length === 1) {
    //        // detect single touch

    //        document.body.scrollTop = this.tempScrolltop;
    //    }

    //}

    //disableRubberBand(event) {
    //    var clientY = event.targetTouches[0].clientY - this._clientY;

    //    if (this.modalRef.current.firstChild.scrollTop === 0 && clientY > 0) {

    //        // element is at the top of its scroll
    //        event.preventDefault();
    //    }

    //    if (this.isOverlayTotallyScrolled() && clientY < 0) {
    //        //element is at the top of its scroll
    //        event.preventDefault();
    //    }
    //}

    //isOverlayTotallyScrolled() {
    //    // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
    //    return this.modalRef.current.firstChild.scrollHeight - this.modalRef.current.firstChild.scrollTop <= this.modalRef.current.firstChild.clientHeight;
    //}


    closeProductDetails(e) {
        e.preventDefault();
        const navigation = this.props.store.navigation;
        const returnUrl = navigation.getReturnFromLocation();
        const query = navigation.getParsedQueryString();
        let returnQuery = "";
        if (query) {
            for (var key of Object.keys(query)) {
                if (key !== "return") {
                    returnQuery += "" + key + "=" + query[key] + "&";
                }
            }

            if (returnQuery[returnQuery.length - 1] === "&") {
                returnQuery = returnQuery.substr(0, returnQuery.length - 1);
            }
        }
        //console.log("closeProductDetails", returnUrl, query, returnQuery);
        if (returnUrl) {
            navigation.navigateToSiteUrl(null, returnUrl, null, null, returnQuery);
        } else {
            navigation.closeProductDialog();
            //navigation.mainRouter.goBack();
        }

    }


    componentWillUnmount() {
        const navigation = this.props.store.navigation;
        navigation.setProductModal(false);
        navigation.setSingleProduct(null);
    }

    componentDidUpdate() {

        const navigation = this.props.store.navigation;
        // See if sku is loaded in navigation.singleProduct
        const {sku, variant} = navigation.getSkuFromLocation();

        // if (this.state.modalOpen) {
            if (sku !== this.state.currentSku) {
                if (navigation.singleProduct && navigation.singleProduct.Variants && navigation.singleProduct.Variants.find(x => x.Sku === sku)) {
                    // No re-fetch necessary 
                } else {
                    navigation.getProductSingle(sku).then(res => {
                            navigation.setSingleProduct(res);

                            // This scrolls window to top on navigatoin
                            this.modalRef.current.firstChild.scrollTop = 0;
                        }
                        , error => {
                            navigation.setSingleProduct(null);
                            // history.back();
                        }
                    );
                }

                this.setState({modalOpen: true, currentSku: sku});
            }
        //}
    }

    componentDidMount() {
        const serverRender = typeof window === 'undefined';
        const navigation = this.props.store.navigation;
        const order = this.props.store.order;
        const {sku, variant} = navigation.getSkuFromLocation();

        //if (serverRender) {
        //    return;
        //}

        

        if (!sku) {
            return;
        }

        // Is this set from serverside?
        // if(navigation.singleProduct !== null){
        //     this.setState({modalOpen: true, currentSku: sku});
        //     return;
        // }
        
        
        
        if (navigation.ProductsView["_" + sku]) {
            // Preload product
            //console.log("Has Preload -Server-render:", sku, navigation.singleProduct);
            const product = navigation.ProductsView["_" + sku];
            const snapShot = JSON.parse(JSON.stringify({...product, Variants: [{...product, Variants: [{...product}]}], Preload: true}));

            navigation.setSingleProduct(snapShot);

            this.setState({modalOpen: true, currentSku: sku});
        }

        navigation.getProductSingle(sku).then(
            res => {
                navigation.setSingleProduct(res);
                this.setState({modalOpen: true, currentSku: sku});


            }, error => {
                navigation.setSingleProduct(null);
               // history.back();
            }
        );

    }


    render() {


        const serverRender = typeof window === 'undefined';

        const navigation = this.props.store.navigation;
        const {sku, variant} = navigation.getSkuFromLocation();

        //console.log("ProductModal-REnder", this.state, sku, variant)

        //const product = navigation.singleProduct;
        //return (<div>IsBot: {navigation.isBot ? "true" : "false"} modalOpen: {this.state.modalOpen ? "Open" : "Closed"} singleProduct: {navigation.singleProduct === null ? "no product" : "has product"}</div>);
        
        // if (!serverRender && !navigation.isBot) {
            return (
                // <div key={"modal-dialog"} ref={this.modalRef} className="rmd-modal-dialog"/>,
                
                <div key={"modal-dialog"} ref={this.modalRef} className="rmd-modal-dialog">
                <Modal
                    key={"modal-component"}
                    container={this.modalRef.current}
                    open={this.state.modalOpen}
                    onClose={(e) => {
                        this.closeProductDetails(e);
                    }}
                    center
                    showCloseIcon={false}
                    focusTrapped={false}
                    scrollClass="scroll-content"
                    classNames={{
                        overlay: "product-overlay scroll-content",
                        modal: "product-dialog product-dialog-modal",
                        closeIcon: "product-dialog-closeIcon"
                    }}
                    animationDuration={0}
                >
                  
                    <ProductDetails onClose={this.closeProductDetails}
                                    container={this.modalRef.current}/>


                </Modal>
                </div>);
                    //];

        // } else {
        //     return (
        //         <div key={"productModal"}
        //              className="rmd-modal-dialog">
        //             <div className="rmd-overlay product-overlay scroll-content">
        //                 <div className="rmd-modal rmd-modalCenter product-dialog product-dialog-modal" role="dialog" aria-modal="true">
        //
        //                     <ProductDetails onClose={this.closeProductDetails}/>
        //                 </div>
        //             </div>
        //
        //         </div>);
        //
        // }
    }
}

@inject("store")
@observer
class ProductGrid extends React.Component {

    // model props
    constructor(props) {
        super(props);

        this.focusProduct = this.focusProduct.bind(this);
        this.openProductDialog = this.openProductDialog.bind(this);
        this.getProductUrl = this.getProductUrl.bind(this);
        //this.state = {productIndex: 0 };
    }

    getProductUrl(sku, urlName) {
        return this.props.navigation.getProductUrl(sku, urlName);
    }

    openProductDialog(e, product, listIndex) {
        e.stopPropagation();
        e.preventDefault();
        this.props.navigation.openProductDialog(product, {listIndex: listIndex});
    }


    focusProduct(e, i, product) {
        e.preventDefault();
    }


    render() {
        //console.debug("GridProduct - RENDER", this.props);
        // Handle single, or grouped products
        const navigation = this.props.navigation;
        const finalProducts = this.props.products;

        if (!finalProducts) return null;
        //console.debug("finalProducts", products, productArray, finalProducts);

        let numbersOfCols = 3;
        //switch (finalProducts.length) {
        //    case 1:
        //        numbersOfCols = 12;
        //        break;
        //    case 2:
        //        numbersOfCols = 6;
        //        break;
        //    case 3:
        //        numbersOfCols = 4;
        //        break;
        //    default:
        //        numbersOfCols = 3;
        //}
        const retina = isRetina();

        const imageWidth = Math.round((1920 / 12) * (numbersOfCols * (retina ? 2 : 1)));

        return (
            <div className="row grid-products" style={{padding: 0}}>
                {finalProducts.map((product, productIndex) => {
                        return (
                            <div className={"col-md-2 col-6"} key={"product-card" + product.ProductId}>
                                <div className="product-card">
                                    <ProductCard
                                        product={product}
                                        orderStore={this.props.store.order}
                                        navigation={this.props.store.navigation}
                                        listIndex={productIndex}
                                        imageWidth={imageWidth}
                                        disableLacyLoad={this.props.disableLacyLoad}
                                        hideVariants={true}
                                    />

                                </div>
                            </div>);
                    }
                )}
            </div>
        );
    }
}

